<template>
  <div id="newDealerContainer">
    <dealer />
  </div>
</template>

<script>
import Dealer from './Dealer'
export default {
  components: {
    Dealer
  }
}
</script>
